import React from "react";
import { StyleProp, TextStyle, ViewStyle } from "react-native";
import {
  LeftRightStyle,
  MessageText,
  MessageTextProps,
} from "react-native-gifted-chat";
import { FormattedChatMessage } from "../../app/types";
import LightTheme from "../theme/LightTheme";

const GiftedMessageText = (props: MessageTextProps<FormattedChatMessage>) => (
  <MessageText
    {...props}
    containerStyle={containerStyle}
    textStyle={textStyle}
    linkStyle={linkStyle}
    customTextStyle={customText}
  />
);

const textStyle: LeftRightStyle<TextStyle> = {
  left: {
    fontSize: 12,
    lineHeight: 16,
    color: LightTheme.font.secondary.color,
    display: "flex",
    width: 250, // todo remove static width
  },
  right: {
    fontSize: 12,
    lineHeight: 16,
    color: LightTheme.font.secondary.color,
    display: "flex",
    width: 250, // todo remove static width
  },
};

const containerStyle: LeftRightStyle<ViewStyle> = {
  left: {
    backgroundColor: "#FDFEFE",
  },
  right: {
    backgroundColor: "#FDFEFE",
  },
};

const linkStyle: LeftRightStyle<TextStyle> = {
  left: { color: "blue" },
  right: { color: "blue" },
};

const customText: StyleProp<TextStyle> = { fontSize: 12, lineHeight: 16 };

export default GiftedMessageText;
